export default {
      id: "areas-1-usage",
      viewBox: "0 0 26 25",
      url: "/" + "assets/sprite.svg#areas-1",
      toString: function () {
        return this.url;
      }
    }